//import context from '../../main.js';
import { uploadChunk, mergeBlock } from './webApi';
async function uploadBigFile(body) {
  let file = body.file;
  let filesize = file.size; //文件整体大小
  let perSize = 6 * 1024 * 1024; //每片大小
  let chunkNumbers = Math.ceil(filesize / perSize); // 总片数，向上取整
  let start = 0; //分片开头
  let end = 0; //分片结尾
  let filename = new Date().getTime() + `.${body.type}`;
  let uploadCompletedNumbers = 0;
  let returnValue = { type: 'Fail', data: null };

  if (body.progressCallback) {
    //假进度
    body.progressCallback(parseInt((0.2 / chunkNumbers) * 100));
    //body.progressCallback(Math.round((0.2 / chunkNumbers) * 100));
  }

  for (let i = 0; i < chunkNumbers; i++) {
    if (body.cancelToken.value) {
      returnValue.type = 'Cancel'; //取消上传
      return returnValue;
    }
    start = end;
    end = start + perSize;
    if (end > filesize) {
      end = filesize;
    }
    const chunk = file.slice(start, end);
    const formData = new FormData();
    formData.append('files[]', chunk, filename);
    let result = await uploadChunk({
      formData: formData,
      index: i,
      perSize: perSize,
      filesize: filesize,
      chunkNumbers: chunkNumbers
    });
    if (result) {
      uploadCompletedNumbers++;
      if (body.progressCallback) {
        //body.progressCallback(Math.round((uploadCompletedNumbers / chunkNumbers) * 100));
        body.progressCallback(parseInt((uploadCompletedNumbers / chunkNumbers) * 100));
      }
    } else {
      break; //一个分片上传失败，就判断为整体失败
    }
  }
  if (uploadCompletedNumbers == chunkNumbers) {
    let result = await mergeBlock({ filename: filename, chunkNumber: chunkNumbers });
    if (result) {
      if (body.cancelToken.value) {
        returnValue.type = 'Cancel'; //取消上传
        return returnValue;
      }
      returnValue.type = 'Success';
      returnValue.data = result.filename;
      return returnValue;
    }
  }
  returnValue.type = 'Fail';
  return returnValue;
}
export { uploadBigFile };
